import React from 'react'
import Servicebanner from '../components/services/Servicebanner.jsx'
import Connect from '../components/Connect.jsx'
import Webappsection from '../components/services/Webappsection.jsx'
import Mobileappsection from '../components/services/Mobileappsection.jsx'
import Saasappsection from '../components/services/Saasappsection.jsx'

const Services = () => {
  return (
    <>
      <div className="">
      <Servicebanner />
      <Webappsection />
      <Mobileappsection />
      <Saasappsection />
      <Connect />
      </div>
    </>
  )
}

export default Services
